import React from 'react';
import { ContentSafeAreaView, InfluencersList } from '../../components';
import { ActionsRow, Container, IconWrapper, Row } from './FeedPage.styles';
import { Text22ExtraBold } from '../../components/utils/Text/Text.styles';
import { ReactComponent as ColumnIcon } from '../../assets/icons/columns.svg';
import { ReactComponent as GridIcon } from '../../assets/icons/grid.svg';
import { useDispatch, useSelector } from 'react-redux';
import { selectGridView, setGridView } from '../../store/slices/influencer/slice';
import { triggerHaptic } from '../../utils/telegram';

const FeedPage = () => {
  const dispatch = useDispatch();
  const gridView = useSelector(selectGridView);

  return (
    <ContentSafeAreaView removeBottom hideScrollbar>
      <Container>
        <Row>
          <Text22ExtraBold>Explore</Text22ExtraBold>
          <ActionsRow>
            <IconWrapper
              onClick={() => {
                triggerHaptic();
                dispatch(setGridView(!gridView));
              }}>
              {gridView ? <ColumnIcon /> : <GridIcon />}
            </IconWrapper>
          </ActionsRow>
        </Row>
        <InfluencersList gridView={gridView} />
      </Container>
    </ContentSafeAreaView>
  );
};

export default FeedPage;
